import { UserPermissions } from 'src/types/users';

export const PERMISSIONS_FALSE: UserPermissions = {
  usersAdm: {
    read: false,
    create: false,
    update: false,
    delete: false,
  },
  usersShopkeepers: {
    read: false,
    create: false,
    update: false,
    delete: false,
  },
  clients: {
    read: false,
    create: false,
    update: false,
    delete: false,
    invoicesHistory: false,
  },
  promoters: {
    read: false,
    create: false,
    update: false,
    delete: false,
  },
  partners: {
    read: false,
    create: false,
    update: false,
    delete: false,
  },
  credit: {
    read: false,
    create: false,
    update: false,
    delete: false,
  },
  benefits: {
    read: false,
    create: false,
    update: false,
    delete: false,
  },
  transactions: {
    read: false,
    create: false,
    update: false,
    delete: false,
  },
  missions: {
    read: false,
    create: false,
    update: false,
    delete: false,
  },
  personalization: {
    read: false,
    create: false,
    update: false,
    delete: false,
  },
  configs: {
    read: false,
    create: false,
    update: false,
    delete: false,
  },
  lpEvents: {
    create: false,
    read: false,
    update: false,
    delete: false,
  },
  trails: {
    create: false,
    read: false,
    update: false,
    delete: false,
    style: false,
  },
};

export const AuthNavigationOptions = [
  'usersAdm',
  'partners',
  'transactions',
  'benefits',
  'banners',
  'credit',
  'usersShopkeepers',
  'companies',
  'redeemables',
  'coupons',
  'promotions',
  'products',
  'inputCreditDebit',
  'conciliation',
  'externals',
  'lpEvents',
  'trails',
];

export const UserPermissionsDict = [
  {
    title: 'Usuários',
    auth: 'users',
    children: [
      {
        title: 'Administradores',
        auth: 'usersAdm',
      },
      {
        title: 'Lojistas',
        auth: 'usersShopkeepers',
      },
      {
        title: 'Clientes',
        auth: 'clients',
      },
      {
        title: 'Promotores',
        auth: 'promoters',
      },
    ],
  },
  {
    title: 'Parceiros',
    auth: 'partners',
  },
  {
    title: 'Benefícios',
    auth: 'benefits',
  },
  {
    title: 'Transações',
    auth: 'transactions',
  },
  {
    title: 'Personalização',
    auth: 'personalization',
  },
  {
    title: 'Crédito',
    auth: 'credit',
  },
  {
    title: 'Missões',
    auth: 'missions',
  },
  {
    title: 'Configurações',
    auth: 'configs',
  },
  {
    title: 'LP Eventos',
    auth: 'lpEvents',
  },
  {
    title: 'Trilha de Conquistas',
    auth: 'trails',
  },
];
